import React from 'react';
import ColorField from '../../../libs/react-components-admin/fields/color-field';

const confirmationBoxWidths = [
  {label: '', value: ''},
  {label: '100%', value: '100'},
  {label: '83.33%', value: '83.33'},
  {label: '66.66%', value: '66.66'},
  {label: '50%', value: '50'},
  {label: '33.33%', value: '33.33'},
  {label: '16.66%', value: '16.66'},
];

class FormSubmissionConfirmationBox extends React.Component {

  constructor(props) {
    super(props);
    let model = props.model;
    if (!model) {
      model = {};
      props.onChange(model);
    }
    this.state = {
      model,
    };
  }

  updateModel(fieldName, value) {
    this.setState(
      prevState => {
        const model = { ...prevState.model };
        model[fieldName] = value;
        return { model };
      },
      () => this.props.onChange(this.state.model));
  }

  render() {
    return <div className="row">
      <div className="col-12 col-md-4">
        <div className="mb-3">
          <label htmlFor="submissionConfirmationBoxWidth" className="form-label">Width</label>
          <select id="submissionConfirmationBoxWidth" name="submissionConfirmationBoxWidth"
                  className="form-select"
                  value={this.state.model.widthInPercent}
                  onChange={e => this.updateModel('widthInPercent', e.target.value)}>
            {confirmationBoxWidths.map(width =>
              <option key={width.value} value={width.value}>{width.label}</option>
            )}
          </select>
        </div>
      </div>
      <div className="col-12 col-md-4">
        <ColorField id="submissionConfirmationBoxBgColor"
                    label="Background color"
                    valueOnChoose="#096709"
                    value={this.state.model.bgColor || ''}
                    onChange={v => this.updateModel('bgColor', v)} />
      </div>
      <div className="col-12 col-md-4">
        <ColorField id="submissionConfirmationBoxFontColor"
                    label="Text color"
                    valueOnChoose="#EEEEEE"
                    value={this.state.model.fontColor}
                    onChange={v=> this.updateModel('fontColor', v)} />
      </div>
    </div>;
  }

}

export default FormSubmissionConfirmationBox;
